export default class AxiosHelper {
    static GetStringErrors = (error) => {
        return Object.values(error?.response?.data.errors).flat();
    };

    static GetStringError = (error) => {
        return AxiosHelper.GetStringErrors(error)[0];
    };
}